import { TriangleAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { errorMessage } from '@/lib/errors'
import { cn } from '@/lib/utils'

interface ErrorStateProps {
  error?: unknown
  title?: string
  description?: string
  fallback?: string
  onRetry?: () => void
  retryLabel?: string
  variant?: 'page' | 'inline'
  className?: string
}

export function ErrorState({ error, title = 'Não foi possível carregar', description, fallback, onRetry, retryLabel = 'Tentar novamente', variant = 'page', className }: ErrorStateProps) {
  const message = description ?? errorMessage(error, fallback)

  if (variant === 'inline') {
    return (
      <div className={cn('rounded-xl border border-destructive/25 bg-destructive/5 p-4 text-sm', className)}>
        <p className="flex items-center gap-2 font-medium">
          <TriangleAlert className="h-4 w-4 text-destructive" />
          {title}
        </p>
        <p className="mt-1 text-muted-foreground">{message}</p>
        {onRetry && (
          <Button variant="outline" size="sm" className="mt-3" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={cn('mx-auto max-w-md py-16 text-center', className)}>
      <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl border border-destructive/25 bg-card text-destructive shadow-xs ring-4 ring-destructive/10">
        <TriangleAlert className="h-5 w-5" />
      </div>
      <h3 className="text-base font-semibold tracking-tight">{title}</h3>
      <p className="mt-1.5 text-sm text-muted-foreground">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-5" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  )
}
